window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end.
 */
window.axios = require('axios');
const token = document.head.querySelector('meta[name="csrf-token"]');
window.axios = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': token.content,
  },
});

window.moment = require('moment');

require('bootstrap-select');
require('jasny-bootstrap');
require('arrive');

/**
 * Material Dashboard Scripts
 */
require('./vendors/material-dashboard/core/bootstrap-material-design.min.js');
require('./vendors/material-dashboard/plugins/perfect-scrollbar.jquery.min.js');
require('./vendors/material-dashboard/plugins/jquery.validate.min.js');
require('./vendors/material-dashboard/plugins/jquery.bootstrap-wizard.js');
require('./vendors/material-dashboard/plugins/bootstrap-datetimepicker.min.js');
require('./vendors/material-dashboard/plugins/bootstrap-notify.js');
require('./vendors/material-dashboard/material-dashboard.js');
